import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-3 shadow-xl text-sm">
      <p className="text-slate-800 font-bold mb-1.5">{label}</p>
      {payload.map((entry, i) => (
        <div key={i} className="flex items-center gap-2 text-xs mb-0.5">
          <div className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.color }} />
          <span className="text-slate-500">{entry.name}:</span>
          <span className="font-semibold text-slate-700">{entry.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function TicketTrendChart({ data }) {
  if (!data || data.length === 0) return null;

  const formatted = data.map(d => ({
    ...d,
    label: d.month ? new Date(d.month + '-01').toLocaleDateString('en-US', { month: 'short', year: '2-digit' }) : d.month,
  }));

  return (
    <div className="corp-card animate-fade-slide-up" style={{ animationDelay: "700ms" }} data-testid="ticket-trend-chart">
      <div className="h-1 w-full bg-[#6366f1]" />
      <div className="p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-base font-bold text-slate-800">Ticket Trend</h3>
            <p className="text-xs text-slate-400 mt-0.5">Monthly volume over time</p>
          </div>
          <span className="text-[10px] text-slate-400 bg-slate-50 px-2 py-1 rounded-md font-semibold uppercase tracking-wider">Monthly</span>
        </div>

        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={formatted}>
            <defs>
              <linearGradient id="gradTotal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#B22234" stopOpacity={0.2} />
                <stop offset="95%" stopColor="#B22234" stopOpacity={0.02} />
              </linearGradient>
              <linearGradient id="gradClosed" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#059669" stopOpacity={0.15} />
                <stop offset="95%" stopColor="#059669" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              dataKey="label"
              tick={{ fill: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans' }}
              axisLine={{ stroke: '#e2e8f0' }}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans' }}
              axisLine={{ stroke: '#e2e8f0' }}
              tickLine={false}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontFamily: 'DM Sans', fontSize: 11, fontWeight: 500 }} />
            <Area type="monotone" dataKey="total" name="Total" stroke="#B22234" strokeWidth={2.5} fill="url(#gradTotal)" dot={{ r: 3, fill: '#B22234', strokeWidth: 0 }} activeDot={{ r: 5, fill: '#B22234' }} />
            <Area type="monotone" dataKey="closed" name="Closed" stroke="#059669" strokeWidth={2} fill="url(#gradClosed)" dot={{ r: 2.5, fill: '#059669', strokeWidth: 0 }} activeDot={{ r: 4, fill: '#059669' }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
